import { Component } from '@angular/core';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import { IDatePickerDirectiveConfig } from 'ng2-date-picker';

@Component({
  selector: 'swb-timepicker',
  templateUrl: './timepicker.component.html'
})

export class TimePickerComponent extends FormEditorBase {

  public config: IDatePickerDirectiveConfig = {
    locale: 'cs',
    showTwentyFourHours: true,
    format: 'HH:mm',
    appendTo: 'body'
  };

  constructor() {
    super();
  }
}
